<script lang="ts" setup>
import { BETA_SIGNUP_URL } from '@/constants/appConstants'

/** Font size for the hero subtitle text on the landing page. */
const HERO_SUBTITLE_FONT_SIZE = '2.5em'

/**
 * Landing-page "Beta tester program" call to action: heading, subtitle, optional description (default slot),
 * and the sign-up button. Renders rows, so place it inside a `v-sheet`.
 */
defineProps<{
  /** Vuetify spacing class for the space above the heading, e.g. `pt-6`. */
  headingClass: string
  subtitle: string
}>()
</script>

<template>
  <v-row :class="headingClass" no-gutters>
    <v-col align="center" justify="center" md="12">
      <div class="bmt" style="font-weight: bold">BETA TESTER PROGRAM</div>
    </v-col>
  </v-row>
  <v-row class="pt-4" no-gutters>
    <v-col align="center" justify="center" md="12">
      <div class="made" :style="{ fontSize: HERO_SUBTITLE_FONT_SIZE }">{{ subtitle }}</div>
    </v-col>
  </v-row>
  <slot />
  <v-row class="pt-12" justify="center" no-gutters>
    <v-col align="center" md="6">
      <v-btn color="primary" :href="BETA_SIGNUP_URL"><v-icon class="mr-2">mdi-human-greeting</v-icon>Sign up as beta tester</v-btn>
    </v-col>
  </v-row>
</template>
